import { Box } from '@chakra-ui/react';

const SearchModal = () => {
  return (
    <Box padding={1} top={100} zIndex={1000}>
      Search
    </Box>
  );
};

export default SearchModal;
